import React from 'react';
import { FormattedMessage } from 'react-intl';

function Titulo() {
  return (
    <h1 className="sectioninicio">
      <FormattedMessage 
        id="app.Titulo"
        defaultMessage="Consultora de Ciberseguridad"
      />
    </h1>
  );
}

export default Titulo;
